<template>
  <transition
    enter-active-class="transition duration-500 ease-out"
    enter-from-class="opacity-0 scale-95"
    enter-to-class="opacity-100 scale-100"
    leave-active-class="transition duration-300 ease-in"
    leave-from-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-95"
  >
    <div v-if="showPopup" class="fixed inset-0 z-[2000] flex items-center justify-center p-4">
      <!-- Backdrop -->
      <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" @click="closePopup"></div>
      
      <!-- Popup Content -->
      <div class="relative bg-white rounded-3xl p-8 max-w-sm w-full shadow-2xl overflow-hidden text-center animate-in zoom-in duration-500">
        <!-- Close Button -->
        <button @click="closePopup" class="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-900 bg-slate-50 hover:bg-slate-100 rounded-full transition-colors">
          <component :is="XIcon" class="w-4 h-4" />
        </button>

        <div class="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm border border-red-100">
          <component :is="ShieldCheckIcon" class="w-8 h-8 text-red-600" />
        </div>

        <h3 class="text-2xl font-bold text-slate-900 tracking-tight mb-2">Join ALARM</h3>
        <p class="text-sm text-slate-500 mb-8 leading-relaxed">Sign up or log in to track your orders, save your wishlist, and get exclusive offers.</p>

        <div class="space-y-3">
          <NuxtLink to="/auth/login" @click="closePopup" class="flex w-full h-12 items-center justify-center bg-slate-900 text-white rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-slate-800 transition-all active:scale-95 shadow-md">
            Log In Now
          </NuxtLink>
          <NuxtLink to="/auth/register" @click="closePopup" class="flex w-full h-12 items-center justify-center bg-white border-2 border-slate-200 text-slate-900 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:border-slate-900 transition-all active:scale-95">
            Create Account
          </NuxtLink>
        </div>
        
        <div class="mt-6 text-[9px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer hover:text-slate-600 transition-colors" @click="closePopup">
            Continue Exploring
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { X as XIcon, ShieldCheck as ShieldCheckIcon } from 'lucide-vue-next'
import { useAuthStore } from '~/stores/auth'

const authStore = useAuthStore()
const showPopup = ref(false)

onMounted(() => {
  // Delay slightly to ensure store is hydrated
  setTimeout(() => {
      // If already logged in, do nothing
      if (authStore.isAuthenticated) return

      // If already dismissed, do nothing
      const isDismissed = localStorage.getItem('auth_popup_dismissed')
      if (isDismissed) return

      // Show after 10 seconds of exploring the site
      setTimeout(() => {
        // Check again in case they logged in during that time
        if (!authStore.isAuthenticated) {
          showPopup.value = true
        }
      }, 10000)
  }, 1000)
})

const closePopup = () => {
  showPopup.value = false
  localStorage.setItem('auth_popup_dismissed', 'true')
}
</script>
